import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	color: string;
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class ColorBlockComponent extends Component<Args> {
	<template>
		<span class="color-block">
			<CommonUiIconComponent @name="RaindropFill" @size="sm" @fill={{@color}} />
		</span>
	</template>
}
